import React from 'react';
import { useCustomTexts } from '../../../../hooks/useCustomTexts';

interface BaseTextsTranslationProps {
  language: {
    label: string;
  };
  formData: {
    title: string;
    subtitle: string;
    welcomeMessage: string;
    inputPlaceholder: string;
    errorMessage: string;
  };
  onChange: (data: any) => void;
}

export function BaseTextsTranslation({ language, formData, onChange }: BaseTextsTranslationProps) {
  const { texts: currentTexts } = useCustomTexts();

  // Ensure texts object exists
  const texts = currentTexts || {
    title: '',
    subtitle: '',
    welcomeMessage: '',
    inputPlaceholder: '',
    errorMessage: ''
  };

  return (
    <div className="grid grid-cols-2 gap-6">
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Title (original)
        </label>
        <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
          {texts.title}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Translated title
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => onChange({ ...formData, title: e.target.value })}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder={`Title in ${language.label}`}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Subtitle (original)
        </label>
        <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
          {texts.subtitle}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Translated subtitle
        </label>
        <input
          type="text"
          value={formData.subtitle}
          onChange={(e) => onChange({ ...formData, subtitle: e.target.value })}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder={`Subtitle in ${language.label}`}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Welcome message (original)
        </label>
        <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
          {texts.welcomeMessage}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Translated Welcome Message
        </label>
        <textarea
          value={formData.welcomeMessage}
          onChange={(e) => onChange({ ...formData, welcomeMessage: e.target.value })}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder={`Welcome message in ${language.label}`}
          rows={3}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Placeholder (original)
        </label>
        <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
          {texts.inputPlaceholder}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Placeholder translated
        </label>
        <input
          type="text"
          value={formData.inputPlaceholder}
          onChange={(e) => onChange({ ...formData, inputPlaceholder: e.target.value })}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder={`Placeholder in ${language.label}`}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Error message (original)
        </label>
        <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
          {texts.errorMessage}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Error message translated
        </label>
        <textarea
          value={formData.errorMessage}
          onChange={(e) => onChange({ ...formData, errorMessage: e.target.value })}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder={`Error message in ${language.label}`}
          rows={3}
        />
      </div>
    </div>
  );
}